import { motion } from "motion/react"
import { useState } from "react"
import { useNavigate } from "react-router"

import Form from "@forento/ui/components/Form"

import { SubmitButton } from "~/components/Button"
import Checkbox from "~/components/Checkbox"
import InputField from "~/components/InputField"
import { useUser } from "~/contexts/UserContext"
import routes from "~/utilities/routes"
import trpc from "~/utilities/trpc"

import Layout, { Logo } from "./Layout"
import { authCardClass, staggerContainer, staggerItem } from "./Layout/authCard"

const SetContactEmailPage: React.FC = () => {
	const user = useUser()
	const navigate = useNavigate()

	const [isAccountEmailChecked, setAccountEmailChecked] = useState(true)
	const [contactEmail, setContactEmail] = useState("")
	const [isSubmitting, setSubmitting] = useState(false)

	const handleSubmit = async () => {
		if (!isAccountEmailChecked && contactEmail.trim().length === 0) return

		setSubmitting(true)
		try {
			await trpc.platform.update.mutate({ contactEmail: isAccountEmailChecked ? user.user!.email : contactEmail })
			await user.reload()

			navigate(routes.main.index())
		} catch (error) {
			console.error(error)
			setSubmitting(false)
			return Promise.reject(error)
		}
		setSubmitting(false)
	}

	return (
		<Layout>
			<Logo />
			<Form onSubmit={handleSubmit} className={authCardClass}>
				<motion.div
					className="flex w-full flex-col items-stretch gap-0"
					variants={staggerContainer}
					initial="hidden"
					animate="visible"
				>
					<motion.div variants={staggerItem}>
						<h1 className="text-left text-xl font-bold tracking-tight text-zinc-900">Set contact email</h1>
						<p className="mt-1.5 text-left text-sm text-zinc-500">This is how your users can reach you.</p>
					</motion.div>

					<motion.div variants={staggerItem} className="mt-6">
						<Checkbox
							label="Use my account's email address"
							isChecked={isAccountEmailChecked}
							onChange={setAccountEmailChecked}
							className="mb-2"
						/>
						{isAccountEmailChecked ? (
							<InputField label="Contact email address" value={user.user!.email} disabled />
						) : (
							<InputField
								label="Contact email address"
								placeholder="e.g. contact@davescourses.com"
								value={contactEmail}
								onChange={setContactEmail}
							/>
						)}
						<p className="mt-2 text-left text-xs leading-relaxed text-zinc-500">
							The contact email will be public to your users, and will also be used in your terms of
							service.
						</p>
					</motion.div>

					<motion.div variants={staggerItem} className="mt-6">
						<SubmitButton
							variant="primary"
							isLoading={isSubmitting}
							className="w-full cursor-pointer rounded-xl py-3 text-sm font-semibold"
						>
							Save contact email
						</SubmitButton>
					</motion.div>
				</motion.div>
			</Form>
		</Layout>
	)
}

export default SetContactEmailPage
